import React from 'react';
import ImageRemover from './ImageRemover.jsx';
import { ImageMattingContextProvider } from './ImageRemoverContext.jsx';

const CaseComponent = () => {
  return (
    <ImageMattingContextProvider>
      <div className={'image-remove-wrapper'}>
          <ImageRemover/>
      </div>
    </ImageMattingContextProvider>
  );
};
export default CaseComponent;
